import React from "react";
import Navigation from "../Navigation/Navigation";
import { MdKeyboardArrowLeft } from "react-icons/md";
import MyProfileEditBankInfo from "../MyProfileEditBankInfo/MyProfileEditBankInfo";
import MyProfileAddBankInfo from "../MyProfileAddBankInfo/MyProfileAddBankInfo";
import { useState } from "react";
import { useEffect } from "react";
import { BankInfoAPI } from "../../Utils/Api/UserProfile";
import { userId } from "../../Utils/LocalStorage";
import { Link, NavLink } from "react-router-dom";
import PrivacyTermsConditions from "../../Components/PrivacyTermsConditions/PrivacyTermsConditions";
import Loader from "../../Components/Loader/Loader";

const MyProfileBankInfoPage = () => {
  const [bankInfoFlag, setBankInfoFlag] = useState(false);
  const [refreshFlag, setRefreshFlag] = useState(false);
  const [currentTab, setcurrentTab] = useState("");
  const [loading, setLoading] = useState(false);

  const path = window.location.href;
  const endPath = path.split("/");

  useEffect(() => {
    if (endPath[4] === "bank-info") {
      setcurrentTab("bankinfo");
    }
  }, []);

  const Bu_id = userId();

  const RefreshFlag = (val) => {
    setRefreshFlag(val);
  };

  const GetBankInfoAPI = async () => {
    let val = {
      bu_id: parseInt(Bu_id),
      api_method: "get",
    };
    // setLoading(true);
    const getBankInfoData = await BankInfoAPI(val);
    // setLoading(false);
    setBankInfoFlag(getBankInfoData.add_bank_info);
  };

  useEffect(() => {
    GetBankInfoAPI();
  }, [refreshFlag]);

  return (
    <>
      {loading === true ? <Loader /> : ""}
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <Navigation />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          <p className="page-text dashboard">
            <Link to={"/dashboard"}>
              <MdKeyboardArrowLeft className="arrow-left" />
              Back
            </Link>
          </p>

          <p className="page-maintitle">My Profile</p>
          <div className="acc-dashboard mt-4">
            <div className="mb-2 tabs_ul">
              <NavLink
                className={
                  currentTab === "generalinfo" ? " activeTab" : "tabs_li"
                }
              >
                General Info
              </NavLink>
              <NavLink to={"/my-profile/business-info"} className={"tabs_li"}>
                Business Info
              </NavLink>
              <NavLink to={"/my-profile/store-info"} className={"tabs_li"}>
                Store Info
              </NavLink>
              <NavLink to={"/my-profile/subscription"} className={"tabs_li"}>
                Subscription
              </NavLink>
              {/* <NavLink to={"/my-profile/bank-info"} className={"tabs_li"}>
                Bank Info
              </NavLink> */}
              {/* <NavLink
                to={"/my-profile/transaction-history"}
                className={"tabs_li"}
              >
                Transaction History
              </NavLink> */}
              <NavLink
                to={"/my-profile/marketplace-membership"}
                className={"tabs_li"}
              >
                Marketplace Membership
              </NavLink>
              <NavLink to="/my-profile/manage-business" className={"tabs_li"}>
                Manage Businesses
              </NavLink>
            </div>
            <div className="mt-3">
              {bankInfoFlag === true ? (
                <MyProfileAddBankInfo RefreshFlagfunc={RefreshFlag} />
              ) : (
                <MyProfileEditBankInfo />
              )}
            </div>
          </div>
        </div>
      </div>
      <PrivacyTermsConditions />
    </>
  );
};

export default MyProfileBankInfoPage;
